import React, { useEffect, useRef, useState, useCallback } from "react";

// library
import dayjs from "dayjs";

// constants
import { convertTimeToLocation } from "../common/constant/constant";

// router
import { useLocation, useNavigate } from "react-router";

// api
import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";

// redux
import { useDispatch, useSelector } from "react-redux";

// Components
import FilterPopup from "./trials-filter/filter-popup";

const LeftConversationList = ({
  initialLoadComplete,
  PAGE_SIZE,
  allTrial,
  onSelectChat,
  selectedChatId,
  onSearch,
  query,
  onClear,
  unreadState,
  updateUnreadState,
  fetchMoreTrials,
  hasMore,
  hasMoreUnread,
  loading,
  isUnread,
  setIsUnread,
  allTrialUnread,
  getAllTrialUnread,
  callDispatchRef,
  search,
  selectedFilter,
  setSelectedFilter,
  prevSelectedFilter,
  setPrevSelectedFilter,
  isApplyFilters,
  setApplyFilters,
}) => {
  console.log('allTrialUnread => ', allTrialUnread)
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const conversationType = queryParams.get("conversation_type") || "unread";
  const dispatch = useDispatch();
  const [markUnread, setMarkUnread] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const scrollRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setMarkUnread(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  function isConversationURL() {
    const path = window.location.pathname;
    const regex = /^\/conversation-list\/[a-f0-9\-]{36}$/;
    return regex.test(path);
  }

  // const filterUnreadTrials = () => {
  //   const unreadTrials = allTrial.filter((trial) => trial.isUnread === true);
  //   setAllTrialUnread(unreadTrials);

  //   if (!isConversationURL() && markUnread && unreadTrials?.length) {
  //     setIsUnread("unread");
  //     navigate(`?conversation_type=unread`);
  //   }
  // };

  // useEffect(() => {
  //   filterUnreadTrials();
  // }, [allTrial]);

  const getInitials = (name) => {
    if (!name) return "";
    return name
      .trim()
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((word) => word[0].toUpperCase())
      .join("");
  };

  const formatTime = (timeString) => {
    const date = dayjs(timeString);
    if (!date.isValid()) return "";
    const isCurrentYear = date.year() === dayjs().year();
    return isCurrentYear
      ? date.format("MM[/]DD [at] hh:mm A")
      : date.format("YYYY[/]MM[/]DD [at] hh:mm A");
  };

  const truncate = (text, limit) => {
    return text?.length > limit ? text.substring(0, limit) + "..." : text;
  };

  const toggleSetMarkUnread = (row) => {
    setMarkUnread(
      row.patientTrialJuncID === markUnread ? "" : row.patientTrialJuncID
    );
    row.patientTrialJuncID === markUnread && setIsOpen(true);
  };

  const markUnreadChat = async (id) => {
    await axios.get(
      `${ENDPOINTS.CONVERSATION.GET_UPDATED_CONVERSATION}?patientTrialJuncId=${id}&read=false`,
      {
        headers: {
          "Content-Type": "application/json-patch+json",
          Accept: "text/plain",
        },
      }
    );
    updateUnreadState(id, true);
    setMarkUnread(false);
    setTimeout(() => {
      callDispatchRef.current = true;
    }, 500);
  };

  // Infinite scroll observer
  const observer = useRef();

const lastChatElementRef = useCallback(
  (node) => {
    if (loading) return;

    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {

        if (isUnread === "unread") {
          if (hasMoreUnread) {
            fetchMoreTrials("unread", false, query);
          }
        } else {
          if (hasMore) {
            fetchMoreTrials("All", false, query);
          }
        }

      }
    });

    if (node) observer.current.observe(node);
  },
  [loading, hasMore, hasMoreUnread, isUnread, query]
);

  const handleOpen = () => {
    setPrevSelectedFilter(selectedFilter); // backup current state
    console.log('setPrevSelectedFilter => ', prevSelectedFilter)
    setOpen(true);
  };

  useEffect(() => {
  if (
    isUnread === "unread" &&
    initialLoadComplete &&
    !loading &&
    hasMoreUnread &&
    allTrialUnread.length > 0 &&
    allTrialUnread.length < PAGE_SIZE
  ) {
    fetchMoreTrials("unread");
    console.log('useffect is called')
  }
  }, [
    allTrialUnread.length,
    hasMoreUnread,
    loading,
    isUnread,
    initialLoadComplete
  ]);





  const handleScroll = () => {
    const div = scrollRef.current;

    if (!div) return;

    const { scrollTop, scrollHeight, clientHeight } = div;

    // Check if user reached bottom
    if (scrollTop + clientHeight >= scrollHeight - 5) {
      // fetchMore();
      if (isApplyFilters && selectedFilter.length > 0) {
        fetchMoreTrials(isUnread, false, query, selectedFilter);
      } else {
        fetchMoreTrials(isUnread, false, query);
      }
    }
  };

  useEffect(() => {
    if (conversationType === "unread") {
      setIsUnread("unread");
    } else {
      setIsUnread("All");
    }
  }, [conversationType]);

  const [open, setOpen] = useState(false);
  const trailData = useSelector((state) => state.trails_name.data);

  useEffect(() => {
    console.log("selectedFilter", selectedFilter);
  }, [selectedFilter]);

  return (
    <div className="bg-white w-[390px] left-list-conversation h-full">
      {/* Search Box */}
      <div className="p-4 flex">
        <div className="flex flex-grow items-center border rounded-lg p-2 table_border h-[44px] text-[#87909e]">
          <span className="text-[000000]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.35 4.35a7.5 7.5 0 0012.3 12.3z"
              />
            </svg>
          </span>
          <input
            type="text"
            placeholder="Search by name"
            value={query}
            className="w-full outline-none ml-2 text-sm"
            onChange={(e) => onSearch(e.target.value)}
          />
          {query && (
            <button
              onClick={onClear}
              style={{
                position: "relative",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                fontSize: "16px",
                color: "#999",
              }}
            >
              ✕
            </button>
          )}
        </div>
        <button
          className={`w-[56px] h-[44px] text-center rounded-[10px] ml-2 border   flex justify-center items-center border-[#245cea]`}
          onClick={handleOpen}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M4 21V14"
              stroke="#1A1A1B"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M4 10V3"
              stroke="#1A1A1B"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12 21V12"
              stroke="#1A1A1B"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12 8V3"
              stroke="#1A1A1B"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M20 21V16"
              stroke="#1A1A1B"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M20 12V3"
              stroke="#1A1A1B"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1 14H7"
              stroke="#1A1A1B"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9 8H15"
              stroke="#1A1A1B"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17 16H23"
              stroke="#1A1A1B"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <FilterPopup
          isOpen={open}
          onClose={() => setOpen(false)}
          items={trailData}
          selected={selectedFilter}
          setSelected={setSelectedFilter}
          prevSelectedFilter = {prevSelectedFilter}
          isApplyFilters={isApplyFilters}
          applyFilters={() => {
            setOpen(false);
            setApplyFilters(true);
          }}
          setApplyFilters={setApplyFilters}
          setPrevSelectedFilter={setPrevSelectedFilter}
        />
      </div>

      {/* Chat List */}
      <div
        className="flex flex-col h-[calc(100vh-150px)] overflow-y-auto"
        ref={scrollRef}
        onScroll={handleScroll}
      >
        <div
          className="flex flex-col justify-between bg-white"
          ref={dropdownRef}
        >
          <div className="ReadTabbing flex flext-row justify-start p-4 gap-2">
            <div
              className={`cursor-pointer rounded-3xl inactive_chat ${isUnread === "unread" ? "active_chat" : ""
                }`}
              onClick={() => {
                setIsUnread("unread");
                navigate(`?conversation_type=unread`);
              }}
            >
              Unread
            </div>
            <div
              className={`cursor-pointer rounded-3xl inactive_chat ${isUnread === "All" ? "active_chat" : ""
                }`}
              onClick={() => {
                setIsUnread("All");
                navigate(`?conversation_type=all`);
              }}
            >
              All
            </div>
          </div>

          {isUnread === "All"
            ? allTrial.map((allChatList, index) => (
              <div
                className={`relative flex pl-4 items-center justify-between h-[82px] bg-white hover:bg-[#F1F1FD] allChatList pr-5
                                      ${allChatList.patientTrialJuncID ===
                    selectedChatId
                    ? "active"
                    : ""
                  }
                                      ${allChatList.isUnread
                    ? "unread-indication"
                    : ""
                  }
                                    `}
                key={index}
                //ref={lastChatElementRef}
              >
                <p
                  className="mr-1 cursor-pointer"
                  onClick={() => {
                    onSelectChat(allChatList.patientTrialJuncID);
                    setTimeout(() => {
                      callDispatchRef.current = true;
                    }, 500);
                  }}
                >
                  <span className="recruiter-intials">
                    {getInitials(allChatList.patientName)}
                  </span>
                </p>
                <div
                  className="h-full w-full flex items-left justify-center flex-col text-left"
                  style={{ color: "#667783" }}
                >
                  <p
                    className="big-text justify-between"
                    onClick={() => {
                      onSelectChat(allChatList.patientTrialJuncID);
                      setTimeout(() => {
                        callDispatchRef.current = true;
                      }, 500);
                    }}
                  >
                    {allChatList.patientName}{" "}
                    <span className="text-xs mt-1 whitespace-nowrap conversation list">
                      {formatTime(
                        convertTimeToLocation(allChatList.lastOutreach)
                      )}
                    </span>
                  </p>
                  <p
                    className="small-text text-xs text-gray-500 block truncate w-3/4 mt-[6px] cursor-pointer"
                    onClick={() => {
                      onSelectChat(allChatList.patientTrialJuncID);
                      setTimeout(() => {
                        callDispatchRef.current = true;
                      }, 500);
                    }}
                  >
                    {truncate(allChatList.msgContent, 35)}
                  </p>
                </div>

                {allChatList.isUnread === false && (
                  <button
                    className="flip-button absolute right-0"
                    onClick={() => toggleSetMarkUnread(allChatList)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                        stroke="#373737"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
                        stroke="#373737"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
                        stroke="#373737"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </button>
                )}
                {markUnread === allChatList.patientTrialJuncID && (
                  <div
                    className="bg-white flex items-center justify-between gap-2 border text-sm rounded-lg absolute px-3 py-2 right-3 top-[40px] z-20 cursor-pointer"
                    onClick={() =>
                      markUnreadChat(allChatList.patientTrialJuncID)
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="22"
                      viewBox="0 0 20 22"
                      fill="none"
                    >
                      <path
                        d="M9.75 8.23486L5.75 8.23486C5.33579 8.23486 5 7.89908 5 7.48486C5 7.07065 5.33579 6.73486 5.75 6.73486L9.75 6.73486C10.1642 6.73486 10.5 7.07065 10.5 7.48486C10.5 7.89908 10.1642 8.23486 9.75 8.23486Z"
                        fill="#1A1A1B"
                      />
                      <path
                        d="M5 11.4849C5 11.0707 5.33579 10.7349 5.75 10.7349H13.75C14.1642 10.7349 14.5 11.0707 14.5 11.4849C14.5 11.8991 14.1642 12.2349 13.75 12.2349H5.75C5.33579 12.2349 5 11.8991 5 11.4849Z"
                        fill="#1A1A1B"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.71644 0.734863H10.7836C12.1553 0.734859 13.2307 0.734855 14.0951 0.805475C14.9752 0.877386 15.7023 1.02624 16.3604 1.36158C17.4424 1.91285 18.322 2.79249 18.8733 3.87442C19.2086 4.53255 19.3575 5.25966 19.4294 6.1398C19.5 7.00414 19.5 8.07957 19.5 9.45128V12.2081C19.5 12.4645 19.5 12.6207 19.4936 12.7568C19.3533 15.7187 16.9838 18.0882 14.0219 18.2284C13.8858 18.2349 13.7139 18.2349 13.4288 18.2349H13.4004L13.3251 18.235C12.4579 18.2405 11.6132 18.5112 10.9043 19.0108L10.8551 19.0457L8.24441 20.9105C6.7399 21.9852 4.76288 20.4332 5.44954 18.7166C5.54183 18.4858 5.37191 18.2349 5.12341 18.2349H4.52166C2.02441 18.2349 1.94453e-07 16.2104 1.94453e-07 13.7132L7.52434e-08 9.4513C-4.57392e-06 8.07958 -8.21054e-06 7.00415 0.0706119 6.1398C0.142522 5.25966 0.291379 4.53255 0.626713 3.87442C1.17798 2.79249 2.05762 1.91285 3.13955 1.36158C3.79769 1.02624 4.52479 0.877386 5.40494 0.805475C6.26929 0.734855 7.34472 0.734859 8.71644 0.734863ZM5.52708 2.30049C4.7397 2.36483 4.23197 2.48845 3.82054 2.69809C3.02085 3.10555 2.37068 3.75572 1.96322 4.5554C1.75359 4.96683 1.62996 5.47457 1.56563 6.26195C1.50058 7.05808 1.5 8.07236 1.5 9.48486V13.7132C1.5 15.382 2.85284 16.7349 4.52166 16.7349H5.12341C6.43311 16.7349 7.32867 18.0576 6.84226 19.2737C6.71197 19.5994 7.08709 19.8938 7.37255 19.6899L9.98329 17.8251L10.0402 17.7846C10.9993 17.1088 12.1422 16.7425 13.3155 16.735L13.4004 16.7349C13.7221 16.7349 13.8553 16.7346 13.951 16.7301C16.1402 16.6265 17.8916 14.8751 17.9952 12.6858C17.9998 12.5899 18 12.4719 18 12.1837V9.48486C18 8.07236 17.9994 7.05808 17.9344 6.26195C17.87 5.47457 17.7464 4.96683 17.5368 4.5554C17.1293 3.75571 16.4791 3.10555 15.6795 2.69809C15.268 2.48845 14.7603 2.36483 13.9729 2.30049C13.1768 2.23545 12.1625 2.23486 10.75 2.23486H8.75C7.33749 2.23486 6.32322 2.23545 5.52708 2.30049Z"
                        fill="#1A1A1B"
                      />
                    </svg>
                    Mark as Unread
                  </div>
                )}
              </div>
            ))
            : allTrialUnread.map((allChatList, index) => {
  const isLastElement = index === allTrialUnread.length - 1;

  return (
    <div
      ref={isLastElement ? lastChatElementRef : null}
      className="cursor-pointer relative flex pl-4 items-center justify-between h-[82px] bg-white hover:bg-[#F1F1FD] allChatList pr-5 unread-indication"
      key={allChatList.patientTrialJuncID} // ✅ Important: DO NOT use index
      onClick={() => {
        onSelectChat(allChatList.patientTrialJuncID);
        setTimeout(() => {
          callDispatchRef.current = true;
        }, 500);
      }}
    >
      <p className="mr-1">
        <span className="recruiter-intials">
          {getInitials(allChatList.patientName)}
        </span>
      </p>

      <div
        className="h-full w-full flex items-left justify-center flex-col text-left"
        style={{ color: "#667783" }}
      >
        <p className="big-text justify-between">
          {allChatList.patientName}{" "}
          <span className="text-xs mt-1 whitespace-nowrap conversation list">
            {formatTime(
              convertTimeToLocation(allChatList.lastOutreach)
            )}
          </span>
        </p>

        <p className="small-text text-xs text-gray-500 block truncate w-3/4 mt-[6px] cursor-pointer">
          {truncate(allChatList.msgContent, 35)}
        </p>
      </div>
    </div>
  );
})
}

          {loading && (
            <div className="text-center py-2 text-gray-400 flex justify-center">
              <div className="mini-spinner mt-3"></div>
            </div>
          )}
          {!loading && isUnread === "All" && allTrial.length === 0 && (
            <div class="w-full p-4 text-center">You have no message</div>
          )}
          {initialLoadComplete && !loading && isUnread === "unread" && allTrialUnread.length === 0 &&
  !hasMoreUnread && (
            <div class="w-full p-4 text-center">You have no unread message</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeftConversationList;
